module.exports = "/app/themes/roboyo2021/dist/img/calendar-wht.png?dda607666c7c77cf733d787a962e8345";